import { useDispatch } from 'react-redux';
import { Card, Container, Stack, StackItem } from '@optimus-web/core';
import { ModalBodyWrapper, ModalWrapper } from '@mews-commander/ui';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import ModalHeader from '../../../legacy/React/Components/Common/ModalHeader';
import { useCloseButton } from '../../../core/windowManager/hooks';
import ExtendEHWPageForm from './ExtendEHWPageForm';
import { ExtendEHWFormValues } from './types';
import { extendEHW } from './actions';

const ExtendEHWPage = () => {
    const closeButton = useCloseButton();
    const dispatch = useDispatch();

    const submitForm = (values: ExtendEHWFormValues) => dispatch(extendEHW(values));

    return (
        <ModalWrapper>
            <ModalHeader title={<LocalizedText textKey={TextKey.ExtendEHW} />} primaryAction={closeButton} />
            <ModalBodyWrapper>
                <Container padding={['400', '0']}>
                    <Stack vertical itemAlignment="center">
                        <StackItem width="700px">
                            <Card padding="300">
                                <ExtendEHWPageForm onSubmit={submitForm} />
                            </Card>
                        </StackItem>
                    </Stack>
                </Container>
            </ModalBodyWrapper>
        </ModalWrapper>
    );
};

export default ExtendEHWPage;
